import React from 'react';

import { SkeletonBlock, SkeletonOverlay, SkeletonTable } from 'components/shared';

const row: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '0 15px',
};

export function FinanceReportSkeleton({
    isLoading,
    kpiCount,
}: {
    isLoading: boolean;
    kpiCount: number;
}) {
    return (
        <SkeletonOverlay isLoading={isLoading} style={{ paddingTop: 15, gap: 15 }}>
            <div style={{ ...row, justifyContent: 'space-between' }}>
                <SkeletonBlock height={32} width={220} />
                <SkeletonBlock height={40} width={180} />
            </div>
            <div style={row}>
                {Array.from({ length: kpiCount }, (_, i) => (
                    <SkeletonBlock key={i} height={96} style={{ flexShrink: 1 }} />
                ))}
            </div>
            <div style={row}>
                <SkeletonBlock height={36} width={360} />
                <div style={{ flexGrow: 1 }} />
                <SkeletonBlock height={36} width={96} />
            </div>
            <SkeletonTable columnWidths={[undefined, 120, 120, 120, 120]} rowCount={8} />
        </SkeletonOverlay>
    );
}
